import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08f041c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "http://beian.miit.gov.cn",
      target: "_blank",
      rel: "nofollow"
    }, "沪ICP备2022031290号-1"),
    /*#__PURE__*/_createTextVNode(" / "),
    /*#__PURE__*/_createElementVNode("img", {
      src: "http://cache.fotoplace.cc/system/fotoplace/netpolice.png",
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode(" 沪公网安备 31010402010041号 / Powered by 2008-2023 UI.CN ")
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}